<template>
  <div ref="dressCodeRef" class="dresscode-container">
    <!-- Flores decorativas -->
    <img ref="flor1Ref" src="@/assets/flor1.png" alt="Flor 1" class="flor flor1" />
    <img ref="flor2Ref" src="@/assets/flor1.png" alt="Flor 2" class="flor flor2" />

    <!-- Título -->
    <h2 ref="dressCodeTitle" class="titulo">Código de Vestimenta</h2>

    <!-- Imagen formal con vestido -->
    <img ref="iconRef" src="@/assets/codigo.png" alt="Código de vestimenta" class="vestimenta-img" />

    <!-- Texto FORMAL -->
    <p ref="textRef" class="formal-text">FORMAL</p>
    <p ref="subtextRef" class="sub-text">Reservamos el Color Lavander y Oro únicamente para la Quinceañera. 
</p>

    <!-- Botón 
    <a ref="btnRef" href="https://pin.it/2zfAX58jv" target="_blank" rel="noopener noreferrer" class="btn-pinterest">
      Pinterest Inspiración idea
    </a>
-->
    <!-- Fondo decorativo edificios -->
    <img ref="edificioRef" src="@/assets/estrella.avif" alt="Edificios" class="edificios-img" />
  </div>
</template>

<script>
import { ref, onMounted, nextTick } from 'vue'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'DressCodeComponent',
  setup() {
    const dressCodeRef = ref(null)
    const dressCodeTitle = ref(null)
    const iconRef = ref(null)
    const textRef = ref(null)
    const subtextRef = ref(null)
    const edificioRef = ref(null)
    const btnRef = ref(null)
    const flor1Ref = ref(null)
    const flor2Ref = ref(null)

    const animateMain = () => {
      const tl = gsap.timeline()
      tl.fromTo(dressCodeTitle.value, { opacity: 0, y: -20 }, { opacity: 1, y: 0, duration: 1 })
        .fromTo(iconRef.value, { opacity: 0, scale: 0.5 }, { opacity: 1, scale: 1, duration: 1.2, ease: 'back.out(1.7)' }, ">-0.3")
        .fromTo(textRef.value, { opacity: 0, y: 20 }, { opacity: 1, y: 0, duration: 0.8 }, ">-0.2")
        .fromTo(subtextRef.value, { opacity: 0, y: 20 }, { opacity: 1, y: 0, duration: 0.8 }, ">-0.3")
        .fromTo(edificioRef.value, { opacity: 0, y: 30 }, { opacity: 0.3, y: 0, duration: 1 }, ">-0.2")
        .fromTo(btnRef.value, { opacity: 0, scale: 0.8 }, { opacity: 1, scale: 1, duration: 0.8 }, ">-0.3")
    }

    const animateFlor = (element, delay = 0) => {
      gsap.fromTo(element, { opacity: 0, y: 20 }, { opacity: 1, y: 0, duration: 1, ease: 'power2.out', delay })
    }

    onMounted(() => {
      nextTick(() => {
        // Main content
        ScrollTrigger.create({
          trigger: dressCodeRef.value,
          start: 'top 80%',
          onEnter: animateMain,
          toggleActions: 'play none none reset'
        })

        // Observer for flowers
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              if (entry.target === flor1Ref.value) animateFlor(flor1Ref.value, 0)
              if (entry.target === flor2Ref.value) animateFlor(flor2Ref.value, 0.2)
            }
          })
        }, { threshold: 0.3 })

        observer.observe(flor1Ref.value)
        observer.observe(flor2Ref.value)
      })
    })

    return {
      dressCodeRef,
      dressCodeTitle,
      iconRef,
      textRef,
      subtextRef,
      edificioRef,
      btnRef,
      flor1Ref,
      flor2Ref,
    }
  }
}
</script>

<style scoped>
.dresscode-container {
  position: relative;
  text-align: center;
  padding: 40px 0;
    overflow: visible;
  background-color: #d9d2f1 !important;

z-index: 12;
  background-size: cover;
  background-position: center;
  max-width: 500px;
  margin: 0 auto;
}

.titulo {
  font-family: 'britishgruesa', cursive;
  font-size: 56px;
  color: #363636;
  margin-bottom: 30px;
  opacity: 0;
}

.vestimenta-img {
  width: 240px;
  height: auto;
  opacity: 0;
  margin-bottom: 30px;
}

.formal-text {
  font-family: 'quote', serif;
  font-size: 24px;
  font-weight: bold;
  color: #000;
  opacity: 0;
  margin-bottom: 10px;
  letter-spacing: 2px;
}

.sub-text {
  font-family: 'quote', serif;
  font-size: 20px;
  color: #000;
  opacity: 0;
  margin-bottom: 30px;
}

.edificios-img {
  width: 30%;
  height: auto;
  opacity: 0;
  margin-top: -50px;
  margin-bottom: -20px;
}

.btn-pinterest {
  background-color: #070707;
  color: white;
  padding: 12px 20px;
  font-family: 'Poppins', sans-serif;
  font-size: 14px;
  border: none;
  border-radius: 25px;
  font-weight: bold;
  cursor: pointer;
  opacity: 0;
  transition: 0.3s ease;
}
.btn-pinterest:hover {
  background-color: #c36d80;
}

/* Flores */
.flor {
  position: absolute;
  opacity: 0;
  width: 120px;
  height: auto;
  z-index: 1;
}
.flor1 {
  top: -90px;
  left: -10px;
}
.flor2 {
  top: 70px;
  right: -60px;
}

</style>
